export default "__VITE_ASSET__BhMTj77k__"